import { IRentsyncTrackingItems } from '@llws/lift-entity-interfaces';
import { DataModifyProcessor } from '@/shared/classes/data-modify-processor';
import { adminRequest } from '@/shared/request-configs/admin-request';
import config from '@/config';

/**
 * Saves Single Rentsync Tracking Item <br>
 * API Endpoints:
 * <li>`/syndication-api/rentsync_tracking_items/${data.id}` <br> via {@link adminRequest.put}</li>
 * <li>'/syndication-api/rentsync_tracking_items' <br> via {@link adminRequest.post}</li>
 * @param {IRentsyncTrackingItems} data - rentsync property to save
 */
export const save = async (
  data: IRentsyncTrackingItems,
) => (data.id
  ? (await adminRequest.put(`/syndication-api/rentsync_tracking_items/${data.id}`, data)).data
  : (await adminRequest.post('/syndication-api/rentsync_tracking_items', data)).data
);

/**
 * Saves Multiple Rentsync Tracking Items <br>
 * API Endpoint - `/syndication-api/rentsync_tracking_items` <br> via {@link DataModifyProcessor.execute}
 * @param {IRentsyncTrackingItems[]} data - rentsync properties to save
 */
export const saveBulk = async (data: IRentsyncTrackingItems[]) => {
  const processor = new DataModifyProcessor<IRentsyncTrackingItems>(`${config.adminGateway}/syndication-api/rentsync_tracking_items`);

  processor.postItems = data.filter((d) => !d.id);
  processor.putItems = data.filter((d) => d.id);

  return processor.execute();
};

export default {
  save,
  saveBulk,
};
